export default __webpack_public_path__ + "static/media/folder.a6e1e3bc.svg";